import { I18n } from 'aws-amplify'

export const Strings = () => ({
  toolbox: I18n.get('Toolbox'),
  chooseToolboxItem: I18n.get('Choose a toolbox item'),
  addWidget: I18n.get('Add New Widget'),
  selectDevice: I18n.get('Select a device')
})
